/**
 * Open a share popin for Facebook, Twitter et Linkedin
 */
export default class SimpleSharePopin {
    constructor(els) {
        this.dom = {
            link: els
        };

        this._prepare();
    }

    _prepare() {
        for (let i = 0; i < this.dom.link.length; i++) {
            let el = this.dom.link[i];
            let where = this.dom.link[i].getAttribute('data-social');
            this._switch(el, where)
        }
    }

    _switch(el, where) {
        switch (where) {
            case 'facebook':
                this._shareFb(el);
                break;

            case 'twitter':
                this._shareTw(el);
                break;

            case 'linkedin':
                this._shareLink(el);
                break;
        }
    }

    _shareFb(el) {
        this._setShareLink(
            el,
            'https://www.facebook.com/sharer/sharer.php?u=' + this._getEncodedPageUrl()
        );
    }

    _shareTw(el) {
        let msg = el.getAttribute('data-message') || '';
        let url = 'https://twitter.com/intent/tweet?url=' + this._getEncodedPageUrl();

        if (msg.trim() !== '') {
            url += '&text=' + encodeURIComponent(msg.trim());
        }

        this._setShareLink(el, url);
    }

    _shareLink(el) {
        this._setShareLink(
            el,
            'https://www.linkedin.com/sharing/share-offsite/?url=' + this._getEncodedPageUrl()
        );
    }

    _getEncodedPageUrl() {
        return encodeURIComponent(window.location.href);
    }

    _setShareLink(el, url) {
        el.setAttribute('href', url);
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopener noreferrer');

        el.onclick = event => {
            event.preventDefault();

            const popUp = window.open(url, 'popupwindow', 'scrollbars=yes,width=800,height=400');

            if (popUp) {
                popUp.opener = null;
                popUp.focus();
            }

            return false;
        };
    }
}
